// extracted by mini-css-extract-plugin
module.exports = {"layers":"Layers_layers__2DF1B","hidden":"Layers_hidden__l3oGP"};